<template>
  <div class=" is-fullwidth">
    <h2 class="title">Artwork</h2>
    <div class="columns">
        <div class="column">
            <div class="box">
                <span class="tag is-info"><span v-if="loading===true">..</span><span v-if="loading===false">{{ incomingOrders.length }}</span></span> incoming <a href="/digitalprint/incoming-orders">new orders</a>
                <div>
                <table class="table is-fullwidth is-size-7" v-if="loading===false && incomingOrderQtys.length > 0">
                        <thead>
                        <tr>
                            <th>Quantity</th>
                            <th>Orders</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in incomingOrderQtys" :key="index">
                              <td>{{ row.label }}</td>
                              <td>{{ row.counter }}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>           
              </div>      
              
        </div>
        <div class="column">
            <div class="box">
                <span class="tag is-info"><span v-if="loading===true">..</span><span v-if="loading===false">{{ newArtworkOrders.length }}</span></span> in <a href="/digitalprint/new-artwork">new artwork</a>
              <div>   
                    <table class="table is-fullwidth is-size-7" v-if="loading===false && newArtworkQtys.length > 0">
                        <thead>
                        <tr>
                            <th>Quantity</th>
                            <th>Orders</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in newArtworkQtys" :key="index">
                              <td>{{ row.label }}</td>
                              <td>{{ row.counter }}</td>
                              </tr>
                          </tbody>
                      </table>
                </div>           
              </div>
        </div>
        <div class="column">
            <div class="box">
                <span class="tag is-info"><span v-if="loading===true">..</span><span v-if="loading===false">{{ qualityCheckOrders.length }}</span></span> waiting on <a href="/digitalprint/quality">quality check</a>
                <div>

                 <table class="table is-fullwidth is-size-7" v-if="loading===false && qcQtys.length > 0">
                        <thead>
                        <tr>
                            <th>Quantity</th>
                            <th>Orders</th>
                          </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in qcQtys" :key="index">
                              <td>{{ row.label }}</td>
                              <td>{{ row.counter }}</td>
                              </tr>
                          </tbody>
                      </table>

                      </div>
                      </div>
        </div>
        
        </div>

    <h2 class="title mt-6">Printing/Cutting</h2>
        <div class="columns">
        <div class="column">
            <div class="box">
                <span class="tag is-info">-</span> waiting on paper print 
                </div>
        </div>
        <div class="column">
            <div class="box">
                <span class="tag is-info">-</span> waiting on paper rolls
                </div>
        </div>
        <div class="column">
            <div class="box">
                <span class="tag is-info">-</span> waiting on cutting
                </div>
        </div>
        
        </div>

    <h2 class="title mt-6">Makeup</h2>
        <div class="columns">
        <div class="column">
            <div class="box">
                <span class="tag is-info">-</span> awaiting makeup
                </div>
        </div>
        <div class="column">
            
        </div>
        <div class="column">
           
        </div>
        
        </div>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
     mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: false,
      locations: [],
      makeuplocations: [],
      ASP_URL : process.env.VUE_APP_ASP_URL,
      incomingOrders: [],
      newArtworkOrders: [],
      qualityCheckOrders: [],
      order_by : "orderdate ASC"
    }
  },
   methods: {
      async getOrders() {
       // this.loading=true
        /*OrderService.getDigitalPrintOrders(this.accessToken, "", "", "")
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );*/

        OrderService.getIncomingArtworkOrders(this.accessToken, "", this.order_by, 0)
        .then(
          (orders => {
            this.$set(this, "incomingOrders", orders);
            //this.loading=false
          }).bind(this)
        );

        OrderService.getNewArtworkOrders(this.accessToken, "", "", this.order_by)
        .then(
          (orders => {
            this.$set(this, "newArtworkOrders", orders);
            //this.loading=false
          }).bind(this)
        );

        OrderService.getQualityArtworkOrders(this.accessToken, "", this.order_by)
        .then(
          (orders => {
            this.$set(this, "qualityCheckOrders", orders);
            //this.loading=false
          }).bind(this)
        );

        

         //this.loading=false
      },
    
    
    
  },
  computed : {
      /*incomingOrders: function () {
       
        let incomingOrders =  this.orders.filter(function(u) {
            if( u.artwork_new == 0 && u.artwork_repeat == 0 && u.completed == 0 ) 
            {
              return 1
            }
          })

          return incomingOrders
       
     },
     newArtworkOrders: function () { 
        let newArtworkOrders =  this.orders.filter(function(u) {
            if( u.artwork_new == 1 && u.artwork_finished == 0 && u.artwork_completed == 0 ) 
            {
              return 1
            }
          })
          return newArtworkOrders
     },
     qualityCheckOrders: function () { 
        let qualityCheckOrders =  this.orders.filter(function(u) {
            if( u.artwork_new == 1 && u.artwork_finished == 1 && u.artwork_completed == 0 ) 
            {
              return 1
            }
          })
          return qualityCheckOrders
     },*/
     newArtworkQtys: function () {
       let quantityObject = []

       this.newArtworkOrders.forEach(order => {    
            let thisLabel = "Unknown"
            let thisId = 0
            if(order.total_qty === 1)
            {
              thisLabel = 1
              thisId = 1
            }
            else if(order.total_qty === 2)
            {
              thisLabel = 2
              thisId = 2
            }
            else if(order.total_qty <= 5)
            {
              thisLabel = "<= 5"
              thisId = 3
            }
            else if(order.total_qty <= 10)
            {
              thisLabel = "<= 10"
              thisId = 4
            }
            else if(order.total_qty >10 && order.total_qty <=50)
            {
              thisLabel = "11-50"
              thisId = 5
            }
            else if(order.total_qty >50 && order.total_qty <=100)
            {
              thisLabel = "51-100"
              thisId = 6
            }
            else if(order.total_qty >100)
            {
              thisLabel = "> 100"
              thisId = 7
            }
            
            let quantity = quantityObject.find(quantity => quantity.label === thisLabel);
            if(quantity)
            {
                quantity.counter++
            }
            else{
                let thisQuantity = {'id' : thisId, 'label' : thisLabel,  'counter' : 1}
                quantityObject.push(thisQuantity)
            }
            
        });

        let sortedQuantities = quantityObject.sort((c1, c2) => (c1.id > c2.id) ? 1 : (c1.id < c2.id) ? -1 : 0);

       return sortedQuantities
     },
     incomingOrderQtys: function () {
       let quantityObject = []

       this.incomingOrders.forEach(order => {    
            let thisLabel = "Unknown"
            let thisId = 0
            if(order.total_qty === 1)
            {
              thisLabel = 1
              thisId = 1
            }
            else if(order.total_qty === 2)
            {
              thisLabel = 2
              thisId = 2
            }
            else if(order.total_qty <= 5)
            {
              thisLabel = "<= 5"
              thisId = 3
            }
            else if(order.total_qty <= 10)
            {
              thisLabel = "<= 10"
              thisId = 4
            }
            else if(order.total_qty >10 && order.total_qty <=50)
            {
              thisLabel = "11-50"
              thisId = 5
            }
            else if(order.total_qty >50 && order.total_qty <=100)
            {
              thisLabel = "51-100"
              thisId = 6
            }
            else if(order.total_qty >100)
            {
              thisLabel = "> 100"
              thisId = 7
            }
            
            let quantity = quantityObject.find(quantity => quantity.label === thisLabel);
            if(quantity)
            {
                quantity.counter++
            }
            else{
                let thisQuantity = {'id' : thisId, 'label' : thisLabel,  'counter' : 1}
                quantityObject.push(thisQuantity)
            }
            
        });

        let sortedQuantities = quantityObject.sort((c1, c2) => (c1.id > c2.id) ? 1 : (c1.id < c2.id) ? -1 : 0);

       return sortedQuantities
     },
     qcQtys: function () {
       let quantityObject = []

       this.qualityCheckOrders.forEach(order => {    
            let thisLabel = "Unknown"
            let thisId = 0
            if(order.total_qty === 1)
            {
              thisLabel = 1
              thisId = 1
            }
            else if(order.total_qty === 2)
            {
              thisLabel = 2
              thisId = 2
            }
            else if(order.total_qty <= 5)
            {
              thisLabel = "<= 5"
              thisId = 3
            }
            else if(order.total_qty <= 10)
            {
              thisLabel = "<= 10"
              thisId = 4
            }
            else if(order.total_qty >10 && order.total_qty <=50)
            {
              thisLabel = "11-50"
              thisId = 5
            }
            else if(order.total_qty >50 && order.total_qty <=100)
            {
              thisLabel = "51-100"
              thisId = 6
            }
            else if(order.total_qty >100)
            {
              thisLabel = "> 100"
              thisId = 7
            }
            
            let quantity = quantityObject.find(quantity => quantity.label === thisLabel);
            if(quantity)
            {
                quantity.counter++
            }
            else{
                let thisQuantity = {'id' : thisId, 'label' : thisLabel,  'counter' : 1}
                quantityObject.push(thisQuantity)
            }
            
        });

        let sortedQuantities = quantityObject.sort((c1, c2) => (c1.id > c2.id) ? 1 : (c1.id < c2.id) ? -1 : 0);

       return sortedQuantities
     },
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    
      
  },
  watch: {
    '$route'() {
      
    }
  }
}


</script>

